<div
  *ngIf="type === 1"
  id="autopayPopup"
  [ngStyle]="{ visibility: popupVisibility }"
  class="popup {{ additionalClasses }}"
>
  <div class="topBlock">
    <div class="topText" style="font-size: 1em !important">Why Choose AutoPay?</div>
    <div class="botText">
      By choosing AutoPay, you opt into worry-free, on-time payments with the lowest rates possible.
    </div>
  </div>

  <div class="OKbtn btn btn-size_normal btn-primary a-self-center" (click)="close()">OK</div>
</div>
<div
  *ngIf="type === 100"
  id="autopayPopup"
  [ngStyle]="{ visibility: popupVisibility }"
  class="popup popup_dentist {{ additionalClasses }}"
>
  <div style="margin: 2em 0 1.2em; font-size: 1.2em; font-weight: 500; color: #111">
    iCreditWorks-Cerified dentist
  </div>
  <!-- <div class="topBlock_trueZero"> -->
  <div style="color: #111; font-size: 0.85em; line-height: 1.38" class="botText botText_dentist">
    A dental provider who completes training and is<br />
    certified by iCreditWorks to present financing to<br />
    dental patients through the Program is an<br />
    <span class="font-weight-bold">iCreditWorks-Cerified dentist</span>
  </div>
  <!-- </div> -->

  <div
    style="font-size: 1.2em"
    class="OKbtn OKbtn_trueZero btn btn-size_normal btn-primary a-self-center"
    (click)="close()"
  >
    OK
  </div>
</div>
<div
  style="
    z-index: 1;
    background-color: #f9f9f9;
    top: 0;
    left: 0;
    right: 0;
    margin: 0 !important;
    bottom: 0 !important;
    border-radius: 0;
    color: #111;
  "
  *ngIf="type === 101"
  id="autopayPopup"
  [ngStyle]="{ visibility: popupVisibility }"
  class="popup popup_dentist {{ additionalClasses }}"
>
  <div style="margin: 2em 0 1.2em; font-size: 1.2em">Are You Sure?</div>
  <div
    class="doctor_avatar"
    [ngClass]="{
      border: showData?.icwPreferred === true,
      'no-border': showData?.icwPreferred === false
    }"
    *ngIf="showData?.imageUrl; else noDoctorImage"
  >
    <img [src]="showData?.imageUrl" alt="" loading="lazy" srcset="" />
  </div>
  <ng-template #noDoctorImage>
    <div
      class="doctor_avatar placeholder"
      [ngClass]="{
        border: showData?.icwPreferred === true,
        border_none: showData?.icwPreferred === true
      }"
      *ngIf="showData?.gender == 'M'"
    >
      <img
        *ngIf="showData?.icwPreferred"
        class="border"
        [src]="sharedDataService.assetsCdn('images/m_icon_preferred.svg')"
        alt=""
        loading="lazy"
        srcset=""
      />
      <img
        *ngIf="!showData?.icwPreferred"
        [src]="sharedDataService.assetsCdn('images/m_icon.svg')"
        alt=""
        loading="lazy"
        srcset=""
      />
    </div>
    <div
      class="doctor_avatar placeholder"
      [ngClass]="{
        border: showData?.icwPreferred === true,
        border_none: showData?.icwPreferred === true
      }"
      *ngIf="showData?.gender == 'F'"
    >
      <img
        *ngIf="showData?.icwPreferred"
        [src]="sharedDataService.assetsCdn('images/f_icon_prederred.svg')"
        alt=""
        loading="lazy"
        srcset=""
      />
      <img
        *ngIf="!showData?.icwPreferred"
        [src]="sharedDataService.assetsCdn('images/f_icon.svg')"
        alt=""
        loading="lazy"
        srcset=""
      />
    </div>
    <div
      class="doctor_avatar placeholder"
      [ngClass]="{
        border: showData?.icwPreferred === true,
        border_none: showData?.icwPreferred === true
      }"
      *ngIf="showData?.gender == null || showData?.gender.length === 0"
    >
      <img
        *ngIf="showData?.icwPreferred"
        [src]="sharedDataService.assetsCdn('images/doctor-empty_preferred.svg')"
        alt=""
        loading="lazy"
        srcset=""
      />
      <img
        *ngIf="!showData?.icwPreferred"
        [src]="sharedDataService.assetsCdn('images/doctor-empty.svg')"
        alt=""
        loading="lazy"
        srcset=""
      />
    </div>
  </ng-template>
  <div style="padding: 0.5em; text-align: center">
    <div class="font-regular-big font-light-black text-truncate font-weight-bold">
      {{ showData.doctorName }}
    </div>
    <div class="font-regular-big font-light-black text-truncate">{{ showData.practiceName }}</div>
  </div>
  <!-- <div class="topBlock_trueZero"> -->
  <div style="font-size: 0.85em; color: #333" class="botText botText_dentist">
    This selection limits potential loan approval to a maximum of
    <span class="font-weight-bold">${{ maxLoanAmount | mask: '0,000' }}.</span>
  </div>
  <div style="margin-top: 3em; font-size: 0.85em; color: #333" class="botText botText_dentist">
    Click <span class="font-weight-bold">Confirm</span> to continue or
    <span class="font-weight-bold">Change</span> to dentist with an iCreditWorks badge <br />
    and potentially qualify for higher loan amount.
  </div>
  <!-- </div> -->

  <div
    style="color: #ea731f; font-size: 0.9em; border-radius: 0"
    class="OKbtn OKbtn_trueZero OKbtn_trueZero_select btn btn-size_normal btn-primary a-self-center"
  >
    <span class="cancelBtn" (click)="close()">Change Dentist</span
    ><span style="width: 50%" (click)="load()">Confirm Dentist</span>
  </div>
</div>
<div
  style="
    z-index: 1;
    background-color: #f9f9f9;
    top: 0;
    left: 0;
    right: 0;
    margin: 0 !important;
    bottom: 0 !important;
    border-radius: 0;
    color: #111;
  "
  *ngIf="type === 102"
  id="autopayPopup"
  [ngStyle]="{ visibility: popupVisibility }"
  class="popup popup_dentist {{ additionalClasses }}"
>
  <div
    (click)="close()"
    style="margin: 0.7em 0.7em 0 auto; height: 1.2em; width: 1.2em"
    class="icon icon_cross-light"
  ></div>
  <div style="margin-top: 0.25em; font-size: 1.35em; line-height: 1.27">
    Your loan request has been<br />
    <span class="font-weight-bold">pre-approved up to</span>
  </div>
  <!-- <div class="topBlock_trueZero"> -->
  <div style="font-size: 1.8em; justify-content: center; display: flex; margin-bottom: 0.5em">
    <span style="margin: auto 0.25em; height: 1em">$</span
    ><span style="height: 1em; font-size: 1.75em">{{(approvedAmount + '').slice(0, (approvedAmount + '').length -3) + ',' + (approvedAmount + '').slice((approvedAmount + '').length - 3)}}</span>
  </div>
  <div style="color: #333">with your selection of this dentist.</div>
  <button
    style="font-size: 1em; padding: 0.8em 2.5em; margin: 1.25em 0 0.75em"
    id="submitBtn"
    class="btn btn-size_normal btn-primary font-lg-medium-big CheckOptionsFormBtn"
    (click)="load()"
  >
    Loan Options
  </button>
  <div
    style="
      font-weight: 500;
      font-size: 1.4em;
      width: 100%;
      border-top: 0.1em solid #858489;
      line-height: 0;
      margin-top: 1em;
    "
  >
    Or
  </div>
  <div
    style="font-size: 1em; padding: 2em; line-height: 1.31; background-color: white"
    class="botText botText_dentist"
  >
    <span class="font-weight-bold">Good News!</span><br />
    You can potentially qualify for up to <span class="font-weight-bold">${{(maxLoanAmount + '').slice(0, (maxLoanAmount + '').length -3) + ',' + (maxLoanAmount + '').slice((maxLoanAmount + '').length - 3)}}</span> by selecting<br />
    an <span class="font-weight-bold">iCreditWorks-Certified</span> dentist
  </div>
  <!-- </div> -->
  <div (click)="dataUpdate()" style="margin-top: 1.75em; font-size: 1.15em; font-weight: 500; color: #ea731f">
    iCreditWorks-Certified Dentist
  </div>
</div>
<div
  *ngIf="type === 2"
  id="autopayPopup"
  [ngStyle]="{ visibility: popupVisibility }"
  class="popup popup_trueZero {{ additionalClasses }}"
>
  <img class="popup_trueZero_img" src="../../../assets/images/true-0-op-3@3x.png')" alt="" loading="lazy" />
  <div class="topBlock_trueZero">
    <div class="botText botText_trueZero">
      This is an installment loan product with a<br />
      <span style="font-weight: 500">0% interest rate</span>. By selecting this offer,<br />
      the principal loan balance is divided into<br />
      12 equal monthly installment payments.
    </div>
  </div>

  <div class="OKbtn OKbtn_trueZero btn btn-size_normal btn-primary a-self-center" (click)="close()">OK</div>
</div>
<div
  *ngIf="type === 3"
  id="autopayPopup"
  [ngStyle]="{ visibility: popupVisibility }"
  class="popup popup_trueZero popup_trueZero_select {{ additionalClasses }}"
>
  <img class="popup_trueZero_img" src="../../../assets/images/true-0-op-3@3x.png')" alt="" loading="lazy" />
  <div class="topBlock_trueZero_select">
    <div class="botText botText_trueZero botText_trueZero_select">
      The amount offered is less than you were approved for. This installment loan product has a
      <span style="font-weight: 500">0% interest</span> rate; the principal loan balance is divided into 12
      monthly installment payments.
    </div>
    <div class="botText botText_trueZero botText_trueZero_select">
      Click <span style="font-weight: 500">Ok</span> to continue or
      <span style="font-weight: 500">Cancel</span><br />
      to make a different selection.
    </div>
  </div>
  <div class="OKbtn OKbtn_trueZero OKbtn_trueZero_select btn btn-size_normal btn-primary a-self-center">
    <span class="cancelBtn" (click)="close()">Cancel</span><span style="width: 50%" (click)="load()">OK</span>
  </div>
</div>
<div
  *ngIf="type === 4"
  id="autopayPopup"
  [ngStyle]="{ visibility: popupVisibility }"
  class="popup popup_trueZero popup_trueZero_select {{ additionalClasses }}"
>
  <img
    class="popup_PayIn4_img"
    src="../../../assets/images/pay-in-4-logo-op-2@4x.png"
    alt=""
    loading="lazy"
  />
  <div class="topBlock_payIn4">
    <!-- <div class="topText">
      Why Choose AutoPay?
    </div> -->
    <div class="botText botText_trueZero botText_trueZero_select">
      The amount offered is less than you were<br />
      approved for. This installment loan product<br />
      has a 0% interest rate; the principal loan<br />
      balance is divided into <span style="font-weight: 500">four (4) equal</span><br />
      <span style="font-weight: 500">payments</span> made over
      <span style="font-weight: 500">six (6) weeks</span>.
    </div>
    <div class="botText botText_trueZero botText_trueZero_select">
      Click <span style="font-weight: 500">Ok</span> to continue or
      <span style="font-weight: 500">Cancel</span><br />
      to make a different selection.
    </div>
  </div>
  <div class="OKbtn OKbtn_trueZero OKbtn_trueZero_select btn btn-size_normal btn-primary a-self-center">
    <span class="cancelBtn" (click)="close()">Cancel</span><span (click)="load()" style="width: 50%">OK</span>
  </div>
</div>
<div
  *ngIf="type === 5"
  id="autopayPopup"
  [ngStyle]="{ visibility: popupVisibility }"
  class="popup popup_promo popup_trueZero_select {{ additionalClasses }}"
>
  <div style="margin-top: 1.75em; font-size: 1.3em; font-weight: 500">“No-Interest” Incentive Loan</div>
  <div class="topBlock_payIn4">
    <div class="botText botText_trueZero botText_promo">
      If the <span style="font-weight: 500">“No-Interest” Incentive Loan</span> is<br />
      paid in full (including any and all fees) within<br />
      <span style="font-weight: 500; text-decoration: underline">{{ promoMonth }}</span> months from the
      funding date of the<br />
      loan (the <span style="font-weight: 500">“No-Interest” Incentive Period</span>),<br />
      the borrower will receive a credit equal to<br />
      all interest paid during the designated<br />
      incentive period.
    </div>
  </div>

  <div class="OKbtn OKbtn_trueZero btn btn-size_normal btn-primary a-self-center" (click)="close()">OK</div>
</div>
